<template>
  <div class="d-flex align-center">
    <v-avatar :size="size" :color="color" class="mr-2 flex-shrink-0">
      <span class="text-caption font-weight-medium text-white">{{ initials }}</span>
    </v-avatar>
    <div class="text-truncate">
      <div class="text-body-2 font-weight-medium text-truncate">{{ name }}</div>
      <div v-if="sub" class="text-caption text-medium-emphasis text-truncate">{{ sub }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QaAgentCell',
  props: {
    name: { type: String, required: true },
    initials: { type: String, default: '' },
    color: { type: String, default: '#1867C0' },
    sub: { type: String, default: '' },
    size: { type: [String, Number], default: 32 },
  },
};
</script>
